module.exports = __webpack_public_path__ + "static/media/W77F1011.556eb2e1.svg";